$color: rgb($globalSettingsFontPrimary)

.overlay
    position: fixed
    top: 0
    left: 0
    bottom: 0
    right: 0
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    background: rgb($globalSettingsBackgroundTertiary)
    z-index: $indexCheckoutSpinner
    color: $color
    font-size: 14px

.cancel
    margin-top: 40px



